module.exports = __webpack_public_path__ + "media/images/logo-branding-0359918f55c6633f014005fc9af2ec3a.png";